import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatSelectChange } from '@angular/material/select';
import { INSGridConfig } from '@norfolk-southern/accessns-components';
import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, GridOptions, IFilter } from 'ag-grid-community';

import { NSCommonConstants } from '@ruby/configs/common.constants';
import { NSThirdPartyConstants } from '@ruby/configs/third-party.constants';
import { IThirdPartyLOA } from '@ruby/modules/third-party/models/third-party.interface';
import { IGridResultOptions } from '@ruby/shared/models/commons/grid.interface';

@Component({
  selector: 'ng-third-party-grid',
  templateUrl: './third-grid.component.html',
  styleUrls: ['./third-grid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThirdGridComponent implements OnChanges {
  @Input() loaData!: Array<IThirdPartyLOA>;
  @Input() companies!: Array<IGridResultOptions>;
  @Input() loading!: boolean;
  @Output() refresh = new EventEmitter();
  columnDefs: Array<ColDef> = NSThirdPartyConstants.columnsDef;
  grid!: AgGridAngular;
  config: INSGridConfig = {
    hide: {
      customizedReporting: false
    },
    dropdown: {
      selected: 0,
      label: 'Filter by Company',
      options: []
    }
  };
  options: GridOptions = {
    rowHeight: 30,
    overlayNoRowsTemplate: NSCommonConstants.noResultsFoundMessage
  };

  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.companies && changes.companies.currentValue.length > 0) {
      this.config.dropdown!.options = [];
      this.config.dropdown!.options.push(...changes.companies.currentValue);
    }
  }

  /**
   * Set Grid
   *
   * @summary The following method is fired when the grid is ready
   * @param $grid: AgGridAngular
   * @returns void
   */
  setGrid($grid: AgGridAngular): void {
    this.grid = $grid;
  }

  /**
   * Options Selected
   *
   * @summary Event that is fired on Mat Selection Change
   * @param $event: MatSelectChange
   * @return void
   */
  optionsSelected($event: MatSelectChange): void {
    if ($event.source.value === 0) {
      this.grid.api.setFilterModel(undefined);
    } else {
      const filter: IFilter = this.grid.api.getFilterInstance('companyName')!;
      filter.setModel({
        values: [this.companies[$event.source.value].value],
        type: 'set',
        filterType: 'text'
      });
      this.grid.api.onFilterChanged();
    }
  }

  /**
   * Refresh Grid
   *
   * @summary This method emit an action to refresh the grid
   * @return void
   */
  refreshGrid(): void {
    this.refresh.emit();
  }
}
